const fontFamilies = {
  roboto: ["roboto", "sans-serif"].join(", "),
  industryLight: ["Industry-Light", "sans-serif"].join(", "),
  industryMedium: ["Industry-Medium", "sans-serif"].join(", "),
  industryDemi: ["Industry-Demi", "sans-serif"].join(", "),
  industryBold: ["Industry-Bold", "sans-serif"].join(", "),
};

export { fontFamilies };
